import React from 'react';
import { components, DropdownIndicatorProps } from 'react-select';

export const ClearIndicator: React.FC<
  DropdownIndicatorProps<{ isClearable: boolean }, false>
> = props => {
  const { selectProps } = props;
  const { isClearable } = selectProps;
  return isClearable ? <components.ClearIndicator {...props} /> : null;
};
